import { html, nothing } from "lit";
import type { FleetInspectorTabId } from "./fleet-workspace-presets.ts";
import { FLEET_INSPECTOR_TABS } from "./fleet-workspace-presets.ts";

export type FleetInspectorPanelContent = Partial<Record<FleetInspectorTabId, unknown>>;

export type FleetInspectorPanelProps = {
  activeTab: FleetInspectorTabId;
  onTabChange: (tab: FleetInspectorTabId) => void;
  panels: FleetInspectorPanelContent;
};

export function renderFleetInspectorPanel(props: FleetInspectorPanelProps) {
  const body = props.panels[props.activeTab];
  return html`
    <div class="fleet-inspector">
      <div class="fleet-inspector__tabs" role="tablist" aria-label="Inspector views">
        ${FLEET_INSPECTOR_TABS.map(
          (tab) => html`
            <button
              type="button"
              role="tab"
              class="fleet-inspector__tab ${props.activeTab === tab.id ? "fleet-inspector__tab--active" : ""}"
              aria-selected=${props.activeTab === tab.id}
              title=${tab.label}
              data-testid=${`fleet-inspector-tab-${tab.id}`}
              @click=${() => props.onTabChange(tab.id)}
            >
              ${tab.label}
            </button>
          `,
        )}
      </div>
      <div class="fleet-inspector__body" role="tabpanel">
        ${body ?? html` <p class="muted fleet-inspector__empty">No content for this view.</p> `}
      </div>
    </div>
  `;
}
